import { render } from "./XAxis.vue?vue&type=template&id=406da60d&scoped=true"
import script from "./XAxis.vue?vue&type=script&lang=js"
export * from "./XAxis.vue?vue&type=script&lang=js"

import "./XAxis.vue?vue&type=style&index=0&id=406da60d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406da60d"]])

export default __exports__